<template>
  <div class="ecahrts" :style="'width: 100%;'+(isMobile?'height:71vw':'height: 620px')"></div>
</template>

<script>
import Query from '@/utils/query'
import nameMap from './nameMap'
import { namesMap } from '@/utils/mapName.js'

export default {
  name: "Map",
  data() {
    return {
      data: []
    }
  },
  mixins: [Query],
  props: ['mapType','isMobile'],
  components: {},
  methods: {
    init() {
      const mapUrl = `/ipdata/static/echarts/${this.mapType}.json`
      this.axios
      .get(mapUrl)
      .then(res => {
        echarts.registerMap(this.mapType, res.data)
        this._loadMapData()
      })
      .catch(error => {
        console.log(error)
      })
    },
    // 加载地图所需数据
    _loadMapData() {
      let api = 0
      switch (this.mapType) {
        case 'china':
          api = 9
          break
        case 'yga':
          api = 5
          break
        case 'world':
          api = 13
          break
      }
      this.getAjax(api, data => {
        this._initWorldMap(this._getFormat(data))
      })
    },
    // 地图
    _initWorldMap(data) {
      const option = {
        tooltip: {
          formatter: function (params) {
            let value = params.value || '-'
            if (params.componentSubType === 'effectScatter') {
              value = params.value[2]
            }
            if (!isNaN(value)) {
              value = (value + '').split('.')
              value = value[0].replace(/(\d{1,3})(?=(?:\d{3})+(?!\d))/g, '$1,')
            }
            // return params.seriesName + '<br/>' + params.name + ' : ' + value
            return params.name + ' : ' + value
          }
        },
        geo: {
          map: this.mapType,
          roam: false,
          top: 20,
          bottom: this.isMobile?90:100,
        },
        nameMap: nameMap,
        visualMap: {
          type: 'continuous',
          show: true,
          min: 0,
          max: data.max / 10,
          text: ['数量多', '数量少'],
          realtime: false,
          calculable: true,
          seriesIndex: [0],
          orient: 'horizontal',
          left: 'center',
          inRange: {
            color: ['#FFF', '#0081ff']
          }
        },
        series: [
          {
            // nameMap: nameMap,
            top: 20,
            bottom: this.isMobile?90:100,
            type: 'map',
            mapType: this.mapType,
            roam: false,
            getIndex: 0,
            itemStyle: {
              emphasis: {label: {show: true}, areaColor: '#0e45cf'}
            },
            data: (()=>{
              if (this.mapType === 'world') {
                data.data.forEach(item => {
                  item.label = {show: true, color: '#333', fontSize: this.isMobile?8:14}
                })
              }
              return data.data
            })(),
            label: {
              normal: {
                show: this.mapType !== 'world',
                position: 'inside',
                fontSize: this.isMobile?6:12,
                textStyle: {
                  color: '#000'
                }
              }
            },
          },
          {
            type: 'effectScatter',
            coordinateSystem: 'geo',
            showEffectOn: 'render',
            rippleEffect: {
              period: 5,
              scale: 6,
              brushType: 'fill'
            },
            symbolSize: (val) => {
              let MAX_SYMBOL_SIZE = this.isMobile?2:10
              let size = Math.floor(Math.log10(1 + (val[2] / data.max) * 10) * MAX_SYMBOL_SIZE)
              size = size < 3 ? 3 : size
              return size
              // return Math.log(val[2]) / Math.log(5)
            },
            symbolOffset: [0, '100%'],
            hoverAnimation: true,
            itemStyle: {
              normal: {
                color: '#e2f135'
              }
            },
            data: this._effectScatter(data)
          }
        ]
      }
      if(this.isMobile && this.mapType !== 'world'){
        option.geo.aspectScale = 1.1
        option.series[0].aspectScale = 1.1
      }
      this._setOption(option)
    },
    _setOption(option) {
      const myChart = echarts.init(this.$el)
      myChart.setOption(option)
    },
    // 替换名称及返回最大值
    _getFormat(data) {
      let max = 0
      data.forEach(item => {
        if (this.mapType === 'china') {
          item.name = item.name.replace(/省/g, '')
          .replace(/市/g, '')
          .replace(/壮族自治区/g, '')
          .replace(/维吾尔自治区/g, '')
          .replace(/回族自治区/g, '')
          .replace(/特别行政区/g, '')
          .replace(/自治区/g, '')
        }
        if(this.mapType === 'world') {
          item.name = namesMap[item.name] || item.name
        }
        if (item.value > max) {
          max = item.value
        }
      })
      return {data: data, max: max}
    },
    _effectScatter(data) {
      const geoCoordMap = this._geoCoordMap(this.mapType)
      const series = data.data
      let temp = []
      for (let i = 0; i < series.length; i++) {
        const geoCoord = geoCoordMap[series[i].name]
        if (geoCoord && series[i].isTop) {
          temp.push({
            name: series[i].name,
            value: geoCoord.concat(series[i].value)
          })
        }
      }
      return temp
    },
    _geoCoordMap(mapName) {
      let geoMap = {}
      const mapFeatures = echarts.getMap(mapName).geoJson.features
      for (let i = 0; i < mapFeatures.length; i++) {
        // 地区名称
        const name = mapFeatures[i].properties.name
        // 地区经纬度
        geoMap[name] = mapFeatures[i].properties.cp
      }
      return geoMap
    }
  },
  computed: {},
  mounted() {
    this.init()
  }
}
</script>
